/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlClientSettings
 */
export interface ControlClientSettings {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlClientSettings
     */
    your_lists: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlClientSettings
     */
    initialized: boolean;
}

/**
 * Check if a given object implements the ControlClientSettings interface.
 */
export function instanceOfControlClientSettings(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "your_lists" in value;
    isInstance = isInstance && "initialized" in value;

    return isInstance;
}

export function ControlClientSettingsFromJSON(json: any): ControlClientSettings {
    return ControlClientSettingsFromJSONTyped(json, false);
}

export function ControlClientSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlClientSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'your_lists': json['your_lists'],
        'initialized': json['initialized'],
    };
}

export function ControlClientSettingsToJSON(value?: ControlClientSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'your_lists': value.your_lists,
        'initialized': value.initialized,
    };
}

